/**
 * Giai đoạn 3 – Thẩm phán duyệt thông báo → Chánh án ký
 * Judge: Văn bản chờ duyệt (AI soạn sẵn, Thẩm phán review & duyệt)
 * Chánh án: Văn bản chờ ký (đã duyệt, Chánh án ký số)
 */
import { useState } from 'react'
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  Breadcrumbs,
  Link,
} from '@mui/material'
import { RateReview, Draw, NavigateNext } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../hooks/redux'

type DocPending = { id: string; caseCode: string; title: string; status: 'pending_review' | 'pending_sign'; content?: string }

const DEFAULT_CONTENT: Record<string, string> = {
  'Thông báo thụ lý vụ án': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
Số: 02/2026/TB-TLST | Ngày: 10/03/2026
THÔNG BÁO THỤ LÝ VỤ ÁN
Kính gửi: Viện kiểm sát; Nguyên đơn; Bị đơn.
Về việc: Vụ án HN-GD-2026-002 – Tranh chấp hôn nhân và gia đình.
Tòa án nhân dân quận 1 thông báo đã thụ lý vụ án. Các bên nộp tạm ứng án phí trong thời hạn 15 ngày làm việc theo Điều 147 BLTTDS.`,
  'Giấy báo nộp tạm ứng án phí': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
Số: 02/2026/TB-AP | Ngày: 10/03/2026
GIẤY BÁO NỘP TẠM ỨNG ÁN PHÍ
Vụ án: HN-GD-2026-002. Nguyên đơn cần nộp tạm ứng án phí theo Thông báo thụ lý. Số tiền và tài khoản xem tại Phụ lục.`,
  'Giấy triệu tập phiên họp': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
Số: 01/2026/GT | Ngày: 15/03/2026
GIẤY TRIỆU TẬP (Phiên họp kiểm tra chứng cứ)
Vụ án: HN-GD-2026-001. Triệu tập các bên tham gia phiên họp lúc 08h00 ngày 25/03/2026 tại Phòng xử án số 3.`,
  'Quyết định đưa vụ án ra xét xử': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
Số: 03/2026/QĐ-ĐVARTX | Ngày: 18/03/2026
QUYẾT ĐỊNH ĐƯA VỤ ÁN DÂN SỰ RA XÉT XỬ
Thẩm phán: Thẩm phán Trần Văn Bình – Tòa án nhân dân quận 1.
Căn cứ Điều 203, 204 Bộ luật Tố tụng dân sự;
Xét hồ sơ vụ án HN-GD-2026-003 – Tranh chấp hôn nhân và gia đình (Nguyên đơn: Nguyễn Thị Mai Linh; Bị đơn: Lê Hoàng Nam). Sau khi thụ lý, Tòa đã tiến hành hòa giải không thành. Hồ sơ đủ điều kiện đưa ra xét xử.
QUYẾT ĐỊNH: Đưa vụ án HN-GD-2026-003 ra xét xử sơ thẩm. Thời gian và địa điểm phiên tòa thông báo bằng Giấy triệu tập riêng.`,
  'Thông báo phiên hòa giải': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
Số: 02/2026/TB-PHG | Ngày: 12/03/2026
THÔNG BÁO PHIÊN HÒA GIẢI
Vụ án: HN-GD-2026-003. Tòa án nhân dân quận 1 thông báo tổ chức phiên hòa giải vào 08h00 ngày 20/03/2026 tại Phòng hòa giải. Các bên có mặt đúng giờ, mang theo CMND/CCCD và chứng cứ liên quan.`,
  'Giấy triệu tập phiên xét xử': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
Số: 04/2026/GT | Ngày: 16/03/2026
GIẤY TRIỆU TẬP (Phiên xét xử sơ thẩm)
Vụ án: DS-2026-004 – Tranh chấp dân sự.
Triệu tập các bên tham gia phiên xét xử sơ thẩm vào 08h00 ngày 18/03/2026 (trực tuyến). Link phiên họp gửi qua hệ thống. Các bên mang theo bản chính chứng cứ đã nộp (nếu có).`,
  'Thông báo thụ lý (HN-GD-2026-006)': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
Số: 06/2026/TB-TLST | Ngày: 11/03/2026
THÔNG BÁO THỤ LÝ VỤ ÁN
Kính gửi: Nguyên đơn Phạm Thị Hồng Nhung; Bị đơn Trần Văn Đức.
Về việc: Vụ án HN-GD-2026-006 – Yêu cầu giải quyết ly hôn.
Tòa án nhân dân quận 1 thông báo đã thụ lý vụ án. Các bên nộp tạm ứng án phí trong thời hạn 15 ngày làm việc theo Điều 147 BLTTDS.`,
  'Giấy báo nộp tạm ứng án phí (DD-2026-008)': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
Số: 08/2026/TB-AP | Ngày: 01/03/2026
GIẤY BÁO NỘP TẠM ỨNG ÁN PHÍ
Vụ án: DD-2026-008 – Tranh chấp quyền sử dụng đất (Nguyên đơn: Đặng Văn Hùng; Bị đơn: Lê Hoàng Nam). Nguyên đơn nộp tạm ứng án phí trong thời hạn 15 ngày. Số tiền và tài khoản tại Phụ lục đính kèm.`,
  'Bản án sơ thẩm (HN-GD-2026-001)': `CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
Độc lập – Tự do – Hạnh phúc
———————————
BẢN ÁN DÂN SỰ SƠ THẨM (Số: 01/2026/BA-DS-ST)
Vụ án: HN-GD-2026-001 – Tranh chấp ly hôn.
Nguyên đơn: Lê Hoàng Nam. Bị đơn: Nguyễn Thị Mai Linh.
Căn cứ Điều 51, 56 Luật Hôn nhân và gia đình 2014; Điều 147, 203 BLTTDS 2015.
QUYẾT ĐỊNH: Chấp nhận yêu cầu ly hôn. Hôn nhân chấm dứt kể từ ngày bản án có hiệu lực. (Chi tiết con chung, tài sản, án phí theo biên bản phiên tòa.)`,
}

const MOCK_PENDING: DocPending[] = [
  { id: '1', caseCode: 'HN-GD-2026-002', title: 'Thông báo thụ lý vụ án', status: 'pending_review' },
  { id: '2', caseCode: 'HN-GD-2026-002', title: 'Giấy báo nộp tạm ứng án phí', status: 'pending_review' },
  { id: '3', caseCode: 'HN-GD-2026-001', title: 'Giấy triệu tập phiên họp', status: 'pending_sign' },
  { id: '4', caseCode: 'HN-GD-2026-003', title: 'Quyết định đưa vụ án ra xét xử', status: 'pending_review' },
  { id: '5', caseCode: 'HN-GD-2026-003', title: 'Thông báo phiên hòa giải', status: 'pending_review' },
  { id: '6', caseCode: 'DS-2026-004', title: 'Giấy triệu tập phiên xét xử', status: 'pending_sign' },
  { id: '7', caseCode: 'HN-GD-2026-006', title: 'Thông báo thụ lý (HN-GD-2026-006)', status: 'pending_review' },
  { id: '8', caseCode: 'DD-2026-008', title: 'Giấy báo nộp tạm ứng án phí (DD-2026-008)', status: 'pending_sign' },
  { id: '9', caseCode: 'HN-GD-2026-001', title: 'Giấy triệu tập phiên họp', status: 'pending_sign' },
  { id: '10', caseCode: 'HN-GD-2026-001', title: 'Bản án sơ thẩm (HN-GD-2026-001)', status: 'pending_review' },
]

export default function DocumentsPendingPage({ embedded = false }: { embedded?: boolean }) {
  const navigate = useNavigate()
  const user = useAppSelector((s) => s.auth.user)
  const [docs, setDocs] = useState<DocPending[]>(() =>
    MOCK_PENDING.map((d) => ({ ...d, content: DEFAULT_CONTENT[d.title] ?? '' }))
  )
  const [snack, setSnack] = useState('')
  const [reviewDoc, setReviewDoc] = useState<DocPending | null>(null)
  const [reviewContent, setReviewContent] = useState('')
  const [viewDoc, setViewDoc] = useState<DocPending | null>(null)

  const isJudge = user?.role === 'judge'
  const isChief = user?.role === 'chief_judge' || user?.role === 'admin'

  const toReview = docs.filter((d) => d.status === 'pending_review')
  const toSign = docs.filter((d) => d.status === 'pending_sign')

  const handleOpenReview = (d: DocPending) => {
    setReviewDoc(d)
    setReviewContent(d.content ?? DEFAULT_CONTENT[d.title] ?? '')
  }

  const handleSaveDraft = () => {
    if (!reviewDoc) return
    setDocs((prev) => prev.map((doc) => (doc.id === reviewDoc.id ? { ...doc, content: reviewContent } : doc)))
    setSnack('Đã lưu bản nháp.')
    setReviewDoc(null)
  }

  const handleApproveFromDialog = () => {
    if (!reviewDoc) return
    setDocs((prev) =>
      prev.map((d) =>
        d.id === reviewDoc.id ? { ...d, status: 'pending_sign' as const, content: reviewContent } : d
      )
    )
    setSnack('Đã duyệt. Văn bản chuyển Chánh án ký.')
    setReviewDoc(null)
  }

  const handleApprove = (id: string) => {
    setDocs((prev) => prev.map((d) => (d.id === id ? { ...d, status: 'pending_sign' as const } : d)))
    setSnack('Đã duyệt. Văn bản chuyển Chánh án ký.')
  }

  const handleSign = (id: string) => {
    setDocs((prev) => prev.filter((d) => d.id !== id))
    setSnack('Đã ký số. Văn bản sẽ gửi đến các bên.')
    setViewDoc(null)
  }

  const openViewDoc = (d: DocPending) => setViewDoc(d)

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {!embedded && (
        <>
          <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ mb: 1 }}>
            <Link component="button" underline="hover" color="inherit" onClick={() => navigate('/workspace')}>Bảng điều khiển</Link>
            <Typography color="text.primary">Văn bản chờ duyệt / Ký</Typography>
          </Breadcrumbs>

          <Typography variant="h5" fontWeight={600} gutterBottom>
            {isJudge ? 'Văn bản chờ duyệt' : 'Văn bản chờ ký'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {isJudge
              ? 'AI đã soạn thảo sẵn nội dung. Thẩm phán xem, chỉnh sửa (nếu cần) và duyệt → chuyển Chánh án ký.'
              : 'Văn bản đã được Thẩm phán duyệt. Chánh án ký số để có hiệu lực và gửi đương sự.'}
          </Typography>
        </>
      )}

      {isJudge && (
        <TableContainer component={Paper} elevation={0} sx={{ border: 1, borderColor: 'divider', borderRadius: 2 }}>
          <Table size="medium">
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell><strong>Vụ án</strong></TableCell>
                <TableCell><strong>Văn bản</strong></TableCell>
                <TableCell><strong>Trạng thái</strong></TableCell>
                <TableCell align="right"><strong>Thao tác</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {toReview.length === 0 ? (
                <TableRow><TableCell colSpan={4} align="center">Không có văn bản chờ duyệt.</TableCell></TableRow>
              ) : (
                toReview.map((d) => (
                  <TableRow key={d.id} hover>
                    <TableCell>{d.caseCode}</TableCell>
                    <TableCell>{d.title}</TableCell>
                    <TableCell><Chip label="Chờ duyệt" size="small" color="warning" /></TableCell>
                    <TableCell align="right">
                      <Button size="small" variant="outlined" sx={{ mr: 0.5 }} onClick={() => handleOpenReview(d)}>Xem & Sửa</Button>
                      <Button size="small" variant="contained" startIcon={<RateReview />} onClick={() => handleApprove(d.id)}>Duyệt</Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {isChief && (
        <TableContainer component={Paper} elevation={0} sx={{ border: 1, borderColor: 'divider', borderRadius: 2 }}>
          <Table size="medium">
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell><strong>Vụ án</strong></TableCell>
                <TableCell><strong>Văn bản</strong></TableCell>
                <TableCell><strong>Trạng thái</strong></TableCell>
                <TableCell align="right"><strong>Thao tác</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {toSign.length === 0 ? (
                <TableRow><TableCell colSpan={4} align="center">Không có văn bản chờ ký.</TableCell></TableRow>
              ) : (
                toSign.map((d) => (
                  <TableRow key={d.id} hover>
                    <TableCell>{d.caseCode}</TableCell>
                    <TableCell>{d.title}</TableCell>
                    <TableCell><Chip label="Chờ Chánh án ký" size="small" color="info" /></TableCell>
                    <TableCell align="right">
                      <Button size="small" variant="outlined" sx={{ mr: 0.5 }} onClick={() => openViewDoc(d)}>Xem</Button>
                      <Button size="small" variant="contained" color="primary" startIcon={<Draw />} onClick={() => handleSign(d.id)}>Ký số</Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!isJudge && !isChief && (
        <Alert severity="info">Chức năng dành cho Thẩm phán (duyệt văn bản) và Chánh án (ký văn bản).</Alert>
      )}

      {/* Dialog Thẩm phán: Xem & Sửa */}
      <Dialog open={!!reviewDoc} onClose={() => setReviewDoc(null)} maxWidth="md" fullWidth>
        <DialogTitle>Xem & Sửa – {reviewDoc?.title}</DialogTitle>
        <DialogContent>
          {reviewDoc && (
            <Box sx={{ pt: 0.5 }}>
              {reviewDoc.title.includes('Bản án') && (
                <Alert severity="info" sx={{ mb: 2 }}>
                  Tra cứu điều luật, án lệ tại Tư vấn pháp luật khi soạn/duyệt bản án.
                  <Button size="small" sx={{ ml: 1 }} onClick={() => { setReviewDoc(null); navigate('/workspace/ai-research'); }}>Mở Tư vấn pháp luật</Button>
                </Alert>
              )}
              <Typography variant="body2" color="text.secondary" gutterBottom>Vụ án: {reviewDoc.caseCode}</Typography>
              <TextField
                fullWidth
                multiline
                minRows={12}
                value={reviewContent}
                onChange={(e) => setReviewContent(e.target.value)}
                variant="outlined"
                size="small"
                placeholder="Nội dung văn bản (AI soạn sẵn, Thẩm phán có thể chỉnh sửa)"
                sx={{ mt: 1, '& .MuiInputBase-input': { fontFamily: 'Times New Roman, serif', fontSize: 14 } }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setReviewDoc(null)}>Hủy</Button>
          <Button variant="outlined" onClick={handleSaveDraft}>Lưu bản nháp</Button>
          <Button variant="contained" startIcon={<RateReview />} onClick={handleApproveFromDialog}>Duyệt và chuyển Chánh án</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Chánh án: Xem (read-only) */}
      <Dialog open={!!viewDoc} onClose={() => setViewDoc(null)} maxWidth="md" fullWidth>
        <DialogTitle>Xem văn bản – {viewDoc?.title}</DialogTitle>
        <DialogContent>
          {viewDoc && (
            <Box sx={{ pt: 0.5 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>Vụ án: {viewDoc.caseCode}</Typography>
              <Paper variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', whiteSpace: 'pre-wrap', fontFamily: 'Times New Roman, serif', fontSize: 14 }}>
                {viewDoc.content ?? DEFAULT_CONTENT[viewDoc.title] ?? 'Nội dung văn bản.'}
              </Paper>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setViewDoc(null)}>Đóng</Button>
          {viewDoc && (
            <Button variant="contained" color="primary" startIcon={<Draw />} onClick={() => handleSign(viewDoc.id)}>Ký số</Button>
          )}
        </DialogActions>
      </Dialog>

      <Snackbar open={!!snack} autoHideDuration={4000} onClose={() => setSnack('')} message={snack} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
    </Box>
  )
}
